/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const HelpArticle32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            d="M15.645 17.24a.534.534 0 01.209-.04.53.53 0 01.486.311.512.512 0 01-.112.565.54.54 0 01-.374.146.508.508 0 01-.209-.982zm-.025-3.428c.114-.023.238-.034.372-.034.187 0 .356.024.506.075.15.05.278.12.384.213a.927.927 0 01.243.335c.057.13.086.275.086.435 0 .151-.021.282-.063.393a1.09 1.09 0 01-.159.288 1.185 1.185 0 01-.21.212c-.077.06-.15.115-.219.166a1.755 1.755 0 00-.179.151.339.339 0 00-.097.168l-.084.418h-.633l-.066-.48a.416.416 0 01.03-.256.67.67 0 01.148-.198c.063-.058.133-.114.21-.167a2.09 2.09 0 00.219-.17.95.95 0 00.172-.204.492.492 0 00.07-.267c0-.12-.04-.215-.118-.286a.47.47 0 00-.324-.106.896.896 0 00-.447.106 3.995 3.995 0 00-.133.073.222.222 0 01-.114.034.207.207 0 01-.191-.111l-.245-.377a2.04 2.04 0 01.24-.173 1.845 1.845 0 01.601-.238z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.068 6H10.4C9.075 6 8 7.033 8 8.307v15.386C8 24.967 9.075 26 10.4 26h11.2c1.324 0 2.4-1.033 2.4-2.307v-11.99a.75.75 0 00-.234-.543l-5.132-4.934A.816.816 0 0018.068 6zM20 16a4 4 0 10-8 0 4 4 0 008 0z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default HelpArticle32;
